export class Country {
  fullName?: string;
  countryCode?: string;
  id?: number;
}
